<template lang="pug">
.form-checkout

  h2 退房

  .ui.icon.warning.message(v-if='delegated')
    i.retweet.icon
    .content
      .header
        | 已签署转让委托
      p
        | 转让委托从
        | {{$formatters.date.to_date_cn(contract.transfer_delegation.date_start)}}
        | 起到
        | {{$formatters.date.to_date_cn(contract.transfer_delegation.date_end)}}
        | 止， 请核对信息。

  .ui.icon.warning.message(v-if='days_to_end > 2')
    i.warning.icon
    .content
      .header
        | 合同未到期
      p 距离合同到期还有 {{days_to_end}} 天， 请核对信息确认无误后继续操作。

  .ui.icon.warning.message(v-if='expired_days > 0')
    i.delete.calendar.icon
    .content
      .header
        | 超期提醒
      p 超过租期 {{expired_days}} 天， 请确认是否违约或需额外加收租金。

  p 请核对房间内物品/水电表后更新以下内容。

  h3
  .ui.form
    h3
    .ui.grid.two.columns.stackable
      .column
        h3.with-actions
          span 物品清单
          .ui.buttons.actions
            .ui.basic.icon.button(@click='dialog_properties = true')
              i.icon.pencil.themed.text
            .ui.basic.icon.button(@click='properties_reset', data-tooltip='重置', data-position='top center', data-inverted="")
              i.icon.recycle.themed.text
        room-properties(:properties='form.properties')
        dialog-edit-properties(:properties.sync='form.properties', :visible.sync='dialog_properties')

      .column
        el-checkbox(v-model='form.return_for_utilities', :label='$config.logic.manual_meter ? "收取水电费" : "退还水电费"')
        br
        br
        h3.with-actions
          span 水电表信息
          .actions.ui.tiny.buttons
            .ui.basic.button.icon(@click='dialog_utilities = true')
              i.pencil.icon.themed.text
        utility-view(v-for='(utility, index) in room.utilities', :paid='room.utilities_paid' :key='index', :data='utility')
        el-dialog(:visible.sync='dialog_utilities', size='large')
          template(v-if='dialog_utilities')
            form-utilities(:no='no', :indialog='true', @exit='dialog_utilities = false')

    template(v-if='delegated')
      h3 委托费用
      .ui.four.fields
        .field
          label 委托手续费
          el-input-number(:value='delegation.delegation_fee', :controls='false', disabled)
        .field
          label 委托日租金
          el-input-number(:value='delegation.price_day', :controls='false', disabled)
        .field
          label 委托天数
          el-input-number(:value='delegation_expire_days', :controls='false', disabled)
        .field
          label 委托总费用
          el-input-number(:value='delegation_cost', :controls='false', disabled)

    h3 退还
    .ui.four.fields
      .field
        label 押金 ( {{contract.deposit_money}} )
        el-input-number(v-model='form.return_deposit_money', :controls='false')
      .field
        label 租金
        el-input-number(v-model='form.return_rent_money', :controls='false')
      .field
        label 其他
        el-input-number(v-model='form.return_other_money', :controls='false')
      .field
        label 退款方式
        payment-method-select(v-model='form.returns_method')

    template(v-if='expired_days > 0')
      h3 逾期租金
      .ui.field.inline
        el-checkbox(v-model='form.if_deduct_expired_rents') 收取逾期租金
        el-checkbox(v-model='form.if_deduct_double_rents', :disabled='!form.if_deduct_expired_rents') 日租金双倍
      .ui.three.fields(:class='{disabled:!form.if_deduct_expired_rents}')
        .field
          label 逾期日租 ( {{expired_rent_per_day}} )
          el-input-number(v-model='form.deduct_expired_rent_per_day', :controls='false')
        .field
          label 逾期天数
          el-input-number(:value='expired_days', :controls='false', disabled)
        .field
          label 逾期日租 ( {{expired_rent_total}} )
          el-input-number(v-model='form.deduct_expired_rent_total', :controls='false')


    h3
    .ui.two.columns.grid
      .column
        h3 损坏/丢失物品
        room-properties(:properties='missing_properties')

        h4 合计 {{$formatters.money(properties_deduct)}} 元
      .column
        h3 赔偿

        .ui.two.fields
          .ui.field
            label 物品赔偿
            el-input-number(v-model='form.deduct_properties_money', :controls='false')
          .ui.field
            label 备注
            el-input(v-model='form.deduct_properties_note_user')

        .ui.two.fields
          .ui.field
            label 其他
            el-input-number(v-model='form.deduct_other_money', :controls='false')
          .ui.field(:class='{disabled:!form.deduct_other_money}')
            label 备注
            el-input(v-model='form.deduct_other_note')

    h3 备注
    .ui.field
      el-input(type='textarea', autosize, placeholder='备注', v-model='form.note_checkout')

    h3 应退金额 (负数为应收)
    .ui.field
      receipts(:receipts='receipts')

    .ui.field.actions
      //.ui.button.icon.labeled.teal(@click='print_draft')
        i.icon.print
        | 生成退房单
      .ui.button.themed.icon.labeled(@click='finish')
        i.icon.checkmark
        | 完成退房
      .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { Differ } from '../../modules'
import { AutoTable } from '../auto'
import { PaymentMethodSelect, Receipts, UtilityView } from '../basic'
import RoomProperties from '../mixed/RoomProperties.vue'
import DialogEditProperties from './DialogEditProperties.vue'
import FormUtilities from './FormUtilities.vue'

export default {
  name: 'form-checkout',
  components: {
    AutoTable,
    DialogEditProperties,
    FormUtilities,
    PaymentMethodSelect,
    Receipts,
    RoomProperties,
    UtilityView,
  },
  props: ['no', 'contract_id'],
  data() {
    return {
      form: {
        return_deposit_money: 0,
        return_rent_money: 0,
        return_other_money: 0,

        deduct_other_money: 0,
        deduct_other_note: '',
        deduct_properties_money: 0,
        deduct_properties_note: '',
        deduct_properties_note_user: '',

        properties: [],
        note_checkout: '退回 1 张房卡、 1 张水电卡；\n电视、空调摇控器收回；\n核对后水阀已关，电闸已关。',
        returns_method: 'cash',
        return_for_utilities: true,

        expired_days: 0,
        deduct_expired_rent_per_day: 0,
        deduct_expired_rent_total: 0,
        if_deduct_expired_rents: false,
        if_deduct_double_rents: true,
      },
      dialog_properties: false,
      dialog_utilities: false,
      template_generated: false,
    }
  },
  watch: {
    properties_deduct() {
      this.form.deduct_properties_money = this.properties_deduct
    },
    'form.deduct_other_note': function () {
      this.update_properties_note()
    },
    'form.deduct_other_money': function () {
      this.update_properties_note()
    },
    'form.deduct_properties_note_user': function () {
      this.update_properties_note()
    },
    missing_properties_text() {
      this.update_properties_note()
    },
    expired_rent_per_day() {
      this.form.deduct_expired_rent_per_day = this.expired_rent_per_day
    },
    expired_rent_total() {
      this.form.deduct_expired_rent_total = this.expired_rent_total
    },
    expired_days() {
      this.form.expired_days = this.expired_days
    },
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    contract() {
      return this.$store.getters.contract(this.contract_id)
    },
    customers() {
      return this.$store.getters.customers_filter(this.contract._customers)
    },
    delegated() {
      return this.contract && this.contract.state === 'delegated'
    },
    delegation() {
      if (this.contract)
        return this.contract.transfer_delegation
      return {}
    },
    delegation_expire_days() {
      if (!this.delegation) return 0
      const days_from_now = Math.max(0, -this.$formatters.date.days_from_now(this.delegation.date_start))
      return Math.min(days_from_now, this.delegation.delegation_days)
    },
    delegation_cost() {
      if (!this.delegation) return 0
      const expired_fee = this.delegation_expire_days * this.delegation.price_day
      const delegation_fee = this.delegation.delegation_fee
      return expired_fee + delegation_fee
    },
    room_properties() {
      return this.properties_info(this.form.properties)
    },
    properties_differs() {
      try {
        return Differ.list(this.room.properties, this.form.properties, '_id')
      } catch (e) {
        return {}
      }
    },
    missing_properties() {
      const missings = []
      for (const { from, to } of this.properties_differs.changes) {
        const quantity_delta = to.quantity - from.quantity
        if (quantity_delta < 0)
          missings.push(Object.assign({}, to, { quantity: -quantity_delta }))
      }
      return missings.concat(this.properties_differs.removes)
    },
    missing_properties_text() {
      let text = ''
      const properties = this.properties_info(this.missing_properties)
      for (const p of properties) {
        text += `${p.quantity} ${p.name}`
        if (p.category)
          text += ` - ${p.category}`
        if (p.variant)
          text += ` (${p.variant})`
        text += '\n'
      }
      return text.trim()
    },
    properties_deduct() {
      const properties = this.properties_info(this.missing_properties)
      let money = 0
      for (const p of properties)
        money += p.quantity * (p.proposed_price || 0)
      return money
    },
    adds_properties() {
      const missings = []
      for (const { from, to } of this.properties_differs.changes) {
        const quantity_delta = to.quantity - from.quantity
        if (quantity_delta > 0)
          missings.push(Object.assign({}, to, { quantity: quantity_delta }))
      }
      return missings.concat(this.properties_differs.adds)
    },
    expired_rent_per_day() {
      const rent_per_month = this.contract.price_month + this.contract.management_fee_month + this.contract.network_fee_month
      let rent_per_day = rent_per_month / 30
      if (this.form.if_deduct_double_rents)
        rent_per_day *= 2
      return Math.ceil(rent_per_day / 5) * 5
    },
    expired_rent_total() {
      return this.form.deduct_expired_rent_per_day * this.expired_days
    },
    expired_days() {
      if (this.contract) {
        const expire_date = this.$moment(this.contract.date_expire || this.contract.date_start)
        const now = this.$moment().utc().startOf('day')
        return -this.$moment.daysBetween(expire_date, now) - 1
      }
      return 0
    },
    days_to_end() {
      if (this.contract) {
        const end_date = this.$moment(this.contract.date_end)
        const now = this.$moment().utc().startOf('day')
        return this.$moment.daysBetween(end_date, now)
      }
      return 0
    },
    utilities_form() {
      const receipts = []
      // Utilities Refund
      if (this.form.return_for_utilities) {
        for (const utility of this.room.utilities) {
          let balance = utility.balance
          if (this.$config.logic.manual_meter)
            balance = utility.mechanical - ((this.room.utilities_paid || {})[utility.type] || 0)

          receipts.push({
            type: utility.type,
            name: this.$formatters.utility_label(utility.type),
            unit: this.$formatters.utility_unit(utility.type),
            unit_price: this.$formatters.utility_price(utility.type),
            quantity: balance,
            balance,
            mechanical: utility.mechanical,
          })
        }
      }
      return receipts
    },
    utilities_form_invert() {
      return this
        .utilities_form
        .map(a => ({
          ...a,
          quantity: -a.quantity,
          balance: -a.balance,
        }))
    },
    receipts() {
      const receipts = []

      if (this.form.return_deposit_money) {
        receipts.push({
          name: '合同押金',
          price: this.form.return_deposit_money,
        })
      }

      if (this.form.return_rent_money) {
        receipts.push({
          name: '租金退还',
          price: this.form.return_rent_money,
        })
      }

      if (this.$config.logic.manual_meter)
        receipts.push(...this.utilities_form_invert)
      else
        receipts.push(...this.utilities_form)

      if (this.form.return_other_money) {
        receipts.push({
          name: '其他退还',
          price: this.form.return_other_money,
        })
      }

      if (this.form.deduct_properties_money !== 0) {
        receipts.push({
          name: '物品赔偿',
          price: -this.form.deduct_properties_money,
        })
      }

      if (this.form.if_deduct_expired_rents) {
        receipts.push({
          name: '超期租金',
          unit: '天',
          unit_price: -this.form.deduct_expired_rent_per_day,
          quantity: this.expired_days,
          price: -this.form.deduct_expired_rent_total,
        })
      }

      if (this.delegation && this.delegation.delegation_fee) {
        receipts.push({
          name: '委托手续费',
          price: -this.delegation.delegation_fee,
        })
      }

      if (this.delegation && this.delegation_expire_days) {
        receipts.push({
          name: '委托费用',
          unit: '天',
          unit_price: -this.delegation.price_day,
          quantity: this.delegation_expire_days,
        })
      }

      if (this.form.deduct_other_money !== 0) {
        receipts.push({
          name: (this.form.deduct_other_note) ? `其他扣除（${this.form.deduct_other_note}）` : '其他扣除',
          price: -this.form.deduct_other_money,
        })
      }

      return receipts
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.form.return_deposit_money = this.contract.deposit_money
      this.properties_reset()

      if (this.expired_days > 0 && !this.delegated)
        this.form.if_deduct_expired_rents = true
      this.form.deduct_expired_rent_per_day = this.expired_rent_per_day
      this.form.expired_days = this.expired_days
      this.form.deduct_expired_rent_total = this.expired_rent_total
    },
    submit_form: MakeForm({
      type: 'put',
      url() { return `contracts/${this.contract_id}/checkout` },
      confirm: '确定退房？',
      payload() {
        return {
          checkout: this.form,
          utilities: this.utilities_form,
        }
      },
      $afterSuccess() {
        this.print_draft()
        this.$store.dispatch('load_summary', this)
        this.$router.back()
      },
    }),
    properties_reset() {
      this.form.properties = JSON.parse(JSON.stringify(this.room.properties))
    },
    properties_info(properties = []) {
      return properties.map((prop) => Object.assign({},
        this.$store.getters.property(prop._id),
        {
          quantity: prop.quantity,
          variant: prop.variant,
          note: prop.note,
        }))
    },
    update_properties_note() {
      this.form.deduct_properties_note = ''

      if (this.form.deduct_properties_note_user)
        this.form.deduct_properties_note += `${this.form.deduct_properties_note_user}；\n`
      if (this.form.deduct_other_money)
        this.form.deduct_properties_note += `${this.form.deduct_other_note || '其他'}：${this.form.deduct_other_money}；\n`
      if (this.missing_properties_text)
        this.form.deduct_properties_note += `${this.missing_properties_text}`
    },
    print_draft() {
      this.$templater.request('checkout', {
        room: this.room,
        checkout: this.form,
        utilities: this.$config.logic.manual_meter ? this.utilities_form_invert : this.utilities_form,
        contract: this.contract,
        customers: this.customers,
        $methods: this.$store.state.summary.payment_methods,
        transfer_delegation: this.delegated ? {
          delegation_days: this.delegation_days,
          delegation_cost: this.delegation_cost,
          price_day: this.delegation.price_day,
          delegation_fee: this.delegation.delegation_fee,
        } : undefined,
      })
      this.template_generated = true
    },
    finish() {
      this.submit_form()
    },
    cancel() {
      this.$router.back()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormCheckout.vue?d37abd04